<template>
<div class="content-wrapper card-page-wrap">
       <cart /> 
</div>
    
</div>
</template>

<script>
    export default {
    }
</script>

<style lang="scss">
.card-page-wrap{
    min-height: calc(100vh - 629px);
    background-color: #EEEEEE;

    h3, h1.h3-style {
    font-size: 26px;
    display: block;
    border-top: none;
    margin-top: 0;
    padding: 0;
}
}
</style>